export const Step = {
  PersonalDetails: 'PersonalDetails',
  HousingDetails: 'HousingDetails',
  PreviousAddress: 'PreviousAddress',
  PrimaryIncome: 'PrimaryIncome',
  PrimaryPreviousIncome: 'PrimaryPreviousIncome',
  ReviewIncome: 'ReviewIncome',
  EditPrimaryIncome: 'EditPrimaryIncome',
  AddAdditionalIncome: 'AddAdditionalIncome',
  EditAdditionalIncome: 'EditAdditionalIncome',
  ReviewCoApplicant: 'ReviewCoApplicant',
  ReviewPersonalDetails: 'ReviewPersonalDetails',
  ReviewHousingDetails: 'ReviewHousingDetails',
  FinalIncomeReview: 'FinalIncomeReview',
  FinalIncomeReviewAdditionalAdd: 'FinalReviewIncomeAdditionalAdd',
  FinalIncomeReviewAdditionalEdit: 'FinalReviewIncomeAdditionalEdit',
  FinalIncomeReviewPrimaryEdit: 'FinalReviewIncomePrimaryEdit',
  RedirectToReview: 'RedirectToReview',
  Done: 'Done',
  ExitToDashboard: 'ExitToDashboard',
};
